

import React from 'react';
import { withRouter } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import RequestProvider from '../../RequestProvider';
import { getContractsQuery } from '../../../common/api';
import SubscriptionInfoComponent from '../components/SubscriptionInfo';







function SubscriptionInfo() {
  return (
    <AuthorisationConsumer>
      {({ selectedOrganisation: { organisationId } = {} }) =>
      <RequestProvider
        requests={{
          getContracts: getContractsQuery()
        }}>

          {(requests) =>
        <SizeMe>
              {({ size: { width } = { width: 0 } }) =>
          <SubscriptionInfoComponent
            width={width}
            organisationId={organisationId}
            {...requests} />}


            </SizeMe>}

        </RequestProvider>}

    </AuthorisationConsumer>);

}

export default withRouter(SubscriptionInfo);